import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PhotoGrid } from "@/components/site/PhotoGrid";

export default function CatalogPage() {
  const [params] = useSearchParams();
  const [photos, setPhotos] = useState([]);
  const [cat, setCat] = useState(params.get("categoria") || "Todos");
  useEffect(() => { api.get("/photos").then((r) => setPhotos(r.data)).catch(() => {}); }, []);

  const cats = useMemo(() => ["Todos", ...new Set(photos.map((p) => p.category))], [photos]);
  const shown = cat === "Todos" ? photos : photos.filter((p) => p.category === cat);

  return (
    <section className="hero-bg pt-[170px] pb-24" data-testid="catalog-page">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Catálogo</p>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">Lo que ya lleva nuestra firma</h1>
        <p className="mt-6 max-w-md text-ink/70">Bodas, galas, cenas y actos que hemos tenido el gusto de dirigir. Haz clic en cualquier imagen para verla de cerca.</p>
        <div className="mt-10 mb-10 flex flex-wrap gap-2" data-testid="catalog-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`rounded-full px-4 py-2 font-brand text-[11px] tracking-[0.15em] uppercase border transition-colors ${cat === c ? "bg-granate text-white border-granate" : "border-ink/15 hover:border-granate"}`} data-testid={`catalog-filter-${c}`}>{c}</button>
          ))}
        </div>
        {shown.length ? <PhotoGrid photos={shown} testPrefix="catalog" /> : <p className="text-ink/60" data-testid="catalog-empty">Pronto añadiremos nuevas fotos.</p>}
      </div>
    </section>
  );
}
